import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export interface GlossaryTerm {
  id: number;
  abbreviation: string;
  fullName?: string | null;
  category?: string | null;
  synonyms?: string | null;
  created: string;
  lastModified: string;
}

export interface GlossaryTermPayload {
  abbreviation: string;
  fullName?: string | null;
  category?: string | null;
  synonyms?: string | null;
}

async function request<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(
      response.status,
      text || response.statusText,
    );
  }

  return (await response.json()) as T;
}

export function getGlossaryTerms(): Promise<GlossaryTerm[]> {
  return request<GlossaryTerm[]>("/api/glossaryterms");
}

export function getGlossaryTermById(termId: number): Promise<GlossaryTerm> {
  return request<GlossaryTerm>(`/api/glossaryterms/${termId}`);
}

export function createGlossaryTerm(
  payload: GlossaryTermPayload,
): Promise<GlossaryTerm> {
  return request<GlossaryTerm>("/api/glossaryterms", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function updateGlossaryTerm(
  termId: number,
  payload: GlossaryTermPayload,
): Promise<GlossaryTerm> {
  return request<GlossaryTerm>(`/api/glossaryterms/${termId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}
